<main class="container-fluid">
  <article class="row bg-white shadow my-3 mx-0">
    <section class="col-12 p-3 mb-5">
      <div class="row mb-3">
        <div class="col-12 col-md-6 d-flex align-items-center mb-md-0 mb-3">
          <img
            src="../../../../../assets/icons/solicitud.png"
            class="img-fluid mr-3"
            alt="imagen_logo_reportes"
          />
          <h5 class="m-0">Reporte de sanciones personas</h5>
        </div>
        <div class="col-12 col-md-6 text-right">
          <button
            type="button"
            class="btn btn-outline-success mr-3"
            (click)="isExportar = !isExportar"
            [attr.aria-expanded]="!isExportar"
          >
            Exportar
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="filtros"
          >
            Ver filtros
          </button>
        </div>
      </div>

      <div id="exportar-form" *ngIf="!isExportar">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="exportarForm" (submit)="submit()">
              <div class="row">
                <div
                  class="col-12 col-sm-4 col-md-3 mb-3"
                  formArrayName="exportarList"
                  *ngFor="
                    let order of exportarForm.controls.exportarList.controls;
                    let i = index
                  "
                >
                  <div class="input-group-text">
                    <input class="mr-1" type="checkbox" [formControlName]="i" />
                    <label class="m-0 text-wrap text-left">{{
                      exportarList[i].name
                    }}</label>
                  </div>
                </div>
                <div class="col-12 col-sm-4 col-md-3 mb-3">
                  <div class="input-group-text">
                    <input
                      class="mr-1"
                      type="checkbox"
                      formControlName="selectAll"
                    />
                    <label class="m-0 text-wrap text-left"
                      >Seleccionar/Deseleccionar Todo</label
                    >
                  </div>
                </div>
                <div class="col-12 text-right">
                  <button
                    class="btn btn-success"
                    type="submit"
                    [disabled]="!exportarForm.valid"
                  >
                    Exportar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Número Resolución</label>
                  <input
                    formControlName="numero_resolucion"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Fecha Expedición de Acto Administrativo</label>
                  <input
                    formControlName="fecha_exp_act_admin"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Número de RNT</label>
                  <input
                    formControlName="numero_rnt"
                    type="number"
                    class="form-control"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Estado sanción</label>
                  <select
                    formControlName="estado_sancion_id"
                    class="form-control"
                  >
                  <option value="" selected="true">
                    SELECCIONE
                  </option>
                  <ng-container *ngFor="let item of estados_sanciones">
                          <option [value]="item.sancion_estado_id">
                            {{ item.desc_sancion_estado }}
                          </option>
                        </ng-container>
                </select>
                </div>
                
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Número de identificación</label>
                  <input
                    formControlName="numero_identificacion"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Departamento</label>
                  <select
                  (change)="onMunicipio()"
                    formControlName="departamento_id"
                    class="form-control"
                  >
                  <option value="" selected="true">
                    SELECCIONE
                  </option>
                  <ng-container *ngFor="let item of departamentos">
                    <option [ngValue]="item.departamento_id">
                      {{ item.descripcion }}
                    </option>
                  </ng-container>
                </select>
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Munucipio</label>
                  <select
                    formControlName="municipio_id"
                    class="form-control"
                  >
                  <option value="" selected="true">
                    SELECCIONE
                  </option>
                  <ng-container *ngFor="let item of municipios">
                    <option [ngValue]="item.municipio_id">
                      {{ item.descripcion }}
                    </option>
                  </ng-container>
                </select>
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Fecha Inicio Sanción</label>
                  <input
                    formControlName="fecha_inicio"
                    (change)="fechaInicioChanges()"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="col-12 col-sm-6 col-md-3 form-group">
                  <label>Fecha Fin Sanción</label>
                  <input
                    formControlName="fecha_fin"
                    [min]="filtro.get('fecha_inicio').value"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="col-12 text-right">
                  <button
                    type="reset"
                    class="btn btn-outline-primary border-0 mr-3"
                    (click)="limpiar()"
                  >
                    Limpiar
                  </button>
                  <button class="btn btn-primary" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive mt-3">
        <app-tablas
          [page]="paginaActual"
          [headers]="headerTabla"
          [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr *ngFor="let item of dataTabla.items">
            <td>{{ item.nombre }}</td>
            <td>{{ item.numero_identificacion }}</td>
            <td>{{ item.desc_dpto }}</td>
            <td>{{ item.desc_municipio }}</td>
            <td>{{ item.direccion }}</td>
            <td>{{ item.numero_telefonico }}</td>
            <td>{{ item.correo }}</td>
            <td>{{ item.correo_fiscal }}</td>
            <td>{{ item.numero_resolucion }}</td>
            <td>{{ item.fecha_exp_acto_admin | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.valor_uvt }}</td>
            <td>{{ item.fecha_eje_acto_admin | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.decreto_1836 }}</td>
            <td>{{ item.fecha_inicial | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.fecha_final | date: "d/MMM/yyyy, h:mm a" }}</td>
            <td>{{ item.codigo_rnt }}</td>
            <td>{{ item.desc_sancion_estado }}</td>
            <td>{{ item.usuario_creacion }}</td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
